import React, { useState } from "react";
import Banner from "../../Components/Banner";
import { Helmet } from "react-helmet-async";
import ServiceNowLeadForm from "../../Components/ServiceNowLeadForm";
import DatabricksHero from "../datab/DatabricksHero";
import FoundationSection from "../datab/FoundationSection";
import ApproachSection from "../datab/ApproachSection";
import DeliverablesSection from "../datab/DeliverablesSection";
import DeliveryPathSection from "../datab/DeliveryPathSection";
import ConsultingCapabilities from "../datab/ConsultingCapabilities";
import ExpertiseFAQSection from "../datab/ExpertiseFAQSection";
import { databricksPagesData } from "../../data/databricksData";
import { Navigate, useParams } from "react-router-dom";
import ContactSection from "../../Components/home/ContactSection";

function DatabricksConsulting() {
  const { slug } = useParams();
  const page = databricksPagesData[slug];
  if (!page || !page.hero) {
    return <Navigate to="/404" replace />;
  }

  return (
    <div>
      {page.seo && (
        <Helmet>
          <title>{page.seo.title}</title>
          <meta name="description" content={page.seo.description} />
          <meta name="keywords" content={page.seo.keywords} />
          <link rel="canonical" href={page.seo.canonical} />
          <meta property="og:title" content={page.seo.title} />
          <meta property="og:description" content={page.seo.description} />
          <meta property="og:url" content={page.seo.canonical} />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Mobikode" />
          <meta property="og:image" content={page.seo.ogImage} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={page.seo.title} />
          <meta name="twitter:description" content={page.seo.description} />
          <meta name="twitter:image" content={page.seo.ogImage} />
        </Helmet>
      )}

      {page.hero && (
        <DatabricksHero
          partnerTitle={page.hero.partnerTitle}
          headingLine1={page.hero.headingLine1}
          headingLine2={page.hero.headingLine2}
          description={page.hero.description}
          ctaText={page.hero.ctaText}
          ctaHref={page.hero.ctaHref}
          cardText={page.hero.cardText}
          bgImageSrc={page.hero.bgImageSrc}
        />
      )}

      {page.foundation && (
        <FoundationSection
          badge={page.foundation.badge}
          title={page.foundation.title}
          description={page.foundation.description}
          imageSrc={page.foundation.imageSrc}
        />
      )}

      {page.approach && (
        <ApproachSection
          badge={page.approach.badge}
          heading={page.approach.heading}
          approachData={page.approach.items}
        />
      )}

      {page.deliverables && (
        <DeliverablesSection
          badge={page.deliverables.badge}
          heading={page.deliverables.heading}
          description={page.deliverables.description}
          deliverables={page.deliverables.items}
        />
      )}

      {page.deliveryPath && (
        <DeliveryPathSection
          badge={page.deliveryPath.badge}
          heading={page.deliveryPath.heading}
          subheading={page.deliveryPath.subheading}
          steps={page.deliveryPath.items}
        />
      )}

      {page.capabilities && page.capabilities.items?.length > 0 && (
        <ConsultingCapabilities
          badge={page.capabilities.badge}
          heading={page.capabilities.heading}
          subheading={page.capabilities.subheading}
          capabilities={page.capabilities.items}
        />
      )}

      {page.faq && page.faq.items?.length > 0 && (
        <ExpertiseFAQSection
          badge={page.faq.badge}
          heading={page.faq.heading}
          subheading={page.faq.subheading}
          faqData={page.faq.items}
        />
      )}

      <section id="databricks-lead-form" className="scroll-mt-24">
        <ContactSection />
      </section>

      {/* <Banner
        title="Start with a clear Databricks implementation plan."
        text="Book a conversation with Mobikode to assess your platform requirements, agree on the right foundations, and identify the first business use cases to take into production."
      /> */}
    </div>
  );
}

export default DatabricksConsulting;
